export class SearchCriteria {
    searchKey: String;
    searchValue: String;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/search-criteria.ts